import { render, staticRenderFns } from "./ThreeColumnGridSection.vue?vue&type=template&id=60ef9c01&scoped=true&"
import script from "./ThreeColumnGridSection.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnGridSection.vue?vue&type=script&lang=js&"
import style0 from "./ThreeColumnGridSection.vue?vue&type=style&index=0&id=60ef9c01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef9c01",
  null
  
)

export default component.exports